import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageInfoService } from 'src/app/_services/messageInfo.service copy';

@Component({
  selector: 'app-sent-message-list-by-user',
  templateUrl: './sent-message-list-by-user.component.html',
  styleUrls: ['./sent-message-list-by-user.component.css']
})
export class SentMessageListByUserComponent implements OnInit {
sentMessageList: any[] = [];
sentMessagesCount: number = 0;
server_user_id: number = 0;
  constructor(private messageInfoService:MessageInfoService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(
      params => {
        this.server_user_id = +params['server_user_id'];
        this.getSentMessagesByUserId();
      }
    )

}

getSentMessagesByUserId() {
  this.messageInfoService.getAllByUser(this.server_user_id).subscribe(
    {
      next:(data)=>{
        this.sentMessageList=data.rs.data
        this.sentMessagesCount=this.sentMessageList.length
      },error:(err)=>{
        console.error("error getAllSentMessages",err)
      }
    }
  )
}
}
